import { atom } from "jotai";

export const notificationPageCountFlagAtom = atom ( false );
export const notificationPageCountAtom = atom ( null );
